import React from 'react'
import PropsTypes from 'prop-types'
import Container from '@material-ui/core/Container'

const MainContent = ({ component }) => {
  return (
    <main>
      <Container>{component}</Container>
    </main>
  )
}

MainContent.propTypes = {
  component: PropsTypes.object.isRequired,
}

export default MainContent
